import { useQuery } from '@tanstack/react-query';

const fetchApiData = async (apiUrl) => {
    const response = await fetch(apiUrl);
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.json();
};

export const useApiData = () => {
    // The query key can include the apiUrl to distinguish different endpoints
    const apiUrl = 'https://api.henleypassportindex.com/api/v2/ultimate-portfolio/portfolio';
    return useQuery({
        queryKey: ['apiData', apiUrl],
        queryFn: () => fetchApiData(apiUrl),
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
    });
};
